<template>
  <div class="system-manage">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="breadcrumb-content"
      style="
        height: 40px;
        background-color: white;
        line-height: 40px;
        border-radius: 4px;
        text-indent: 10px;
      "
    >
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top: 10px">
      <div class="system-top">
        <el-button size="mini" type="primary" @click="systemInfo">新 增</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column prop="companyName" label="系统名称" align="center">
        </el-table-column>
        <el-table-column prop="companyId" label="系统Id" align="center"></el-table-column>
         <el-table-column label="系统简称" prop="systemShortName" align="center"></el-table-column>
        <el-table-column label="logo" prop="systemLogo" align="center">
            <el-image :src="this.imageUrl" fit="scale-down" style="width: 160px; height:80px"></el-image>
        </el-table-column>
        <el-table-column prop="savePath" label="系统路径" align="center">
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>

        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="info"
              icon="el-icon-edit"
              @click="systemInfo(scope.row)"
              >编 辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteSystemItem(scope.row.companyId)"
              >删 除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="changePage"
        :current-page="params.pageNo"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </el-card>
    <!-- 新增/编辑 弹框 -->
    <el-dialog
      :title="title"
      :visible.sync="addVisible"
      width="30%"
      :append-to-body="true"
      top="5vh"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="系统名称" prop="companyName">
          <el-input
            v-model="ruleForm.companyName"
            placeholder="请输入系统名称"
            :disabled="title == '编辑'"
          ></el-input>
        </el-form-item>
        <el-form-item label="保存路径" prop="savePath">
          <el-input
            v-model="ruleForm.savePath"
            placeholder="请输入系统路径"
          ></el-input>
        </el-form-item>
        <el-form-item label="系统简称" prop="systemShortName">
          <el-input
            v-model="ruleForm.systemShortName"
            placeholder="请输入系统简称"
            :disable="title == '编辑'"
          ></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload
            class="avatar-uploader"
            action="http://192.168.18.162:9001/crm/Mikael/common/file/upload"
            :show-file-list="false"
            style="width: 200px;height:90px;"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addSystem('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  addSystemData,
  updateSystemData,
  deleteSystemData,
  getSystemData,
} from "@/api/systemMange";
import { clearInputContent, hasBtnPermission } from "@/utils";

export default {
  name: "systemManage",
  data() {
    return {
      title: "",
      addVisible: false,
      totalCount: null,
      tableData: [],
      params: {
        companyName: "",
        pageNo: 1,
        pageSize: 10,
        userCode: "",
      },
      ruleForm: {
        companyName: "",
        userCode: "",
        savePath: "",
        systemShortName: "",
        systemLogo: "",
      },
      rules: {
        companyName: [
          { required: true, message: "请输入系统名称", trigger: "blur" },
        ],
        savePath: [
          { required: true, message: "请输入系统路径", trigger: "blur" },
        ],
        systemShortName: [
          { required: true, message: "请输入系统简称", trigger: "blur" },
        ],
        systemLogo: [{ required: true, trigger: "blur" }],
      },
      imageUrl:require('/src/assets/image/logo4.png')
    };
  },
  created() {
    this.getSystemDataList();
  },
  methods: {
    // 获取系统列表
    async getSystemDataList() {
      this.params.userCode = JSON.parse(
        window.sessionStorage.getItem("userInfo")
      ).userId;
      const res = await getSystemData(this.params);
      if (res.code) {
        this.tableData = res.data.list;
        this.totalCount = res.data.total;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 添加系统
    addSystem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.title === "新增"
            ? this.confirmAddSystem()
            : this.confirmChangeSystem();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 确认新增
    async confirmAddSystem() {
      this.ruleForm.userCode = JSON.parse(
        window.sessionStorage.getItem("userInfo")
      ).userId;
      const res = await addSystemData(this.ruleForm);
      if (res.code === "200") {
        this.$message.success("添加成功");
        this.getSystemDataList();
        this.addVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 确认删除
    async confirmChangeSystem() {
      this.ruleForm.userCode = JSON.parse(
        window.sessionStorage.getItem("userInfo")
      ).userId;
      const res = await updateSystemData(this.ruleForm);
      if (res.code === "200") {
        this.$message.success("添加成功");
        this.getSystemDataList();
        this.addVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 删除系统
    deleteSystemItem(companyId) {
      this.$confirm("确定删除该数据吗?", "提示")
        .then((_) => {
          this.confirmDeleteSystem(companyId);
        })
        .catch((_) => {});
    },
    async confirmDeleteSystem(companyId) {
      let params = {
        companyId: companyId,
        userCode: JSON.parse(window.sessionStorage.getItem("userInfo")).userId,
      };
      const res = await deleteSystemData(params);
      if (res.code === "200") {
        this.$message.success("删除成功");
        this.getSystemDataList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 修改系统信息
    systemInfo(item) {
      if (item.companyName) {
        this.title = "编辑";
        this.ruleForm = JSON.parse(JSON.stringify(item));
      } else {
        this.title = "新增";
        clearInputContent(this.ruleForm);
      }
      this.addVisible = true;
    },
    // 清空输入框内容
    clearInputContent(item) {
      if (item)
        for (let key in item) {
          item[key] = "";
        }
    },
    changePage(e) {
      this.params.pageNo = e;
      this.getSystemDataList();
    },
    handleSizeChange(e){
      this.params.pageNo = 1;
      this.params.pageSize = e;
      this.getPageData()
    },
    handleClose() {
      this.addVisible = false;
    },
    handleAvatarSuccess(res, file) {
        this.imageUrl = res.data;
      },
  },
};
</script>

<style scoped>
::v-deep .el-upload{
  width: 180px;
  height: 90px;
}
</style>
<style scoped lang="scss">
.system-manage {
  .system-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 80px;
  display: block;
}
.pagination{
  margin: 20px 0 0;
}
</style>
